import { render, staticRenderFns } from "./ScreenInfo.vue?vue&type=template&id=8348c79e&scoped=true"
import script from "./ScreenInfo.vue?vue&type=script&lang=js"
export * from "./ScreenInfo.vue?vue&type=script&lang=js"
import style0 from "./ScreenInfo.vue?vue&type=style&index=0&id=8348c79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8348c79e",
  null
  
)

export default component.exports